import React from 'react'
import PropTypes from 'prop-types'

import CircularProgress from 'material-ui/CircularProgress'
import _ from 'lodash'

import PhotoItem from './PhotoItem'
import CommonRepository from 'billing/infra/CommonRepository'

export default class ReferencedEventPhotos extends React.Component {

  static propTypes = {
    referencedEvent: PropTypes.object.isRequired,
    style: PropTypes.object.isRequired,
    onPhotoSelectionChanged: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      list: null
    }
  }

  addEventPhotosListener = props => {
    // Single work orders have start and end date properties set,
    // recurring events are identified only by the endDate (instance) value
    if (props.referencedEvent.startDate) {
      CommonRepository.addEventPhotosListener(props.referencedEvent.eventId,
        this.onEventPhotosValue)
    }
    else {
      CommonRepository.addEventInstancePhotosListener(props.referencedEvent.eventId,
        props.referencedEvent.endDate,
        this.onEventPhotosValue)
    }
  }

  removeEventPhotosListener = props => {
    if (props.referencedEvent.startDate) {
      CommonRepository.removeEventPhotosListener(props.referencedEvent.eventId,
        this.onEventPhotosValue)
    }
    else {
      CommonRepository.removeEventInstancePhotosListener(props.referencedEvent.eventId,
        props.referencedEvent.endDate,
        this.onEventPhotosValue)
      
    }
  }

  componentDidMount() {
    this.addEventPhotosListener(this.props)
  }

  componentWillUnmount() {
    this.removeEventPhotosListener(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.referencedEvent !== nextProps.referencedEvent) {
      this.setState({
        list: null
      })
      this.removeEventPhotosListener(this.props)
      this.addEventPhotosListener(nextProps)
    }
  }

  onEventPhotosValue = snapshot => {
    const photos = snapshot && snapshot.val()
    this.setState({
      list: photos && _.keys(photos).filter(key => !photos[key].delete).map(key => ({
        eventId: this.props.referencedEvent.eventId,
        photoId: key,
        dbPath: photos[key].dbPath,
        name: photos[key].name,
        jobDateStr: photos[key].jobDateStr
      })) || []
    })
  }

  handlePhotoSelectionChanged = (photo, selectionStatus, sample) => {
    const sampledPhoto = Object.assign({}, photo, { sample })
    this.props.onPhotoSelectionChanged(sampledPhoto, selectionStatus)
  }

  render() {
    let content
    if (this.state.list === null) {
      content = <div style={styles.progress}>
        <CircularProgress thickness={2} />
      </div>
    }
    else
    if (!this.state.list.length) {
      content = <div style={styles.zeroItems}>This job does not contain any photos.</div>
    }
    else {
      content = this.state.list.map((photo, index) =>
        <PhotoItem
          key={index}
          photo={photo}
          selectable={true}
          sample='small'
          onPhotoItemSelectionChanged={(selectionStatus, sample) => this.handlePhotoSelectionChanged(photo, selectionStatus, sample)}
          style={index < this.state.list.length - 1 && styles.photosDivider || {}} />)
    }
    return (
      <div style={{ ...styles.container, ...this.props.style }}>
        <div style={styles.eventName}>
          { this.props.referencedEvent.name }
        </div>
        <div style={styles.eventDate}>
          { this.props.referencedEvent.startDate
            ? `${this.props.referencedEvent.startDate} - ${this.props.referencedEvent.endDate}`
            : `${this.props.referencedEvent.endDate}`
          }
        </div>
        <div style={styles.list}>
          { content }
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  zeroItems: {
    textAlign: 'center',
    fontSize: 14,
    paddingTop: 12,
    paddingBottom: 12
  },
  progress: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: 22
  },
  eventName: {
    fontSize: 16,
    color: '#4a4a4a',
    marginBottom: 2
  },
  eventDate: {
    fontSize: 12,
    color: '#9b9b9b',
    marginBottom: 12
  },
  list: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  photosDivider: {
    marginRight: 14
  }
}



// WEBPACK FOOTER //
// ./src/billing/invoices/modules/photos/ReferencedEventPhotos.js